module.exports = __webpack_public_path__ + "img-dashboard/register/document-circle-blue.7327f8bd.png";